import { render, staticRenderFns } from "./FailedPoa.vue?vue&type=template&id=1bb1dd9e&"
import script from "./FailedPoa.vue?vue&type=script&lang=js&"
export * from "./FailedPoa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports